import { render, staticRenderFns } from "./WithdrawMethodList.vue?vue&type=template&id=c887cef4&"
import script from "./WithdrawMethodList.vue?vue&type=script&lang=js&"
export * from "./WithdrawMethodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports